<div class="modern-grid-wrapper">
  <div class="grid-header">
    <div class="header-dots">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <h2 class="grid-main-title">{{ title | translate }}</h2>
    <div class="title-underline"></div>
    <p class="grid-subtitle">{{ subtitle | translate }}</p>
  </div>

  <div class="grid-container">
    @for (submodule of submodules(); track trackByPath($index, submodule)) {
    <div
      class="module-card group"
      [attr.data-color]="submodule.theme"
      (click)="navigateToSubmodule(submodule.path)"
      [ngClass]="'theme-' + submodule.theme"
      role="button"
      tabindex="0"
    >
      <!-- Decoración de fondo -->
      <div
        class="card-decoration absolute top-0 right-0 w-32 h-32 opacity-20 pointer-events-none"
      >
        <div
          class="w-full h-full rounded-full blur-3xl"
          [ngClass]="'bg-gradient-to-br ' + (submodule.bgGradient || 'from-blue-400 to-purple-400')"
        ></div>
      </div>

      <!-- ICONO -->
      <div class="icon-display">
        <div
          class="icon-circle"
          [ngClass]="'bg-gradient-to-br ' + (submodule.bgGradient || 'from-blue-500 to-purple-500')"
        >
          @if (submodule.icon.startsWith('assets/')) {
            <img
              [src]="submodule.icon"
              [alt]="(submodule.title | translate)"
              class="module-icon-png"
              onerror="this.src = 'assets/images/svgs/icon-user-male.svg'"
            />
          } @else {
            <i class="iconify module-icon-3d" [attr.data-icon]="submodule.icon"></i>
          }
        </div>
        <div class="icon-line" [ngClass]="'bg-' + submodule.theme"></div>
      </div>

      <!-- INFORMACIÓN -->
      <div class="module-info">
        <h3 class="module-name" [ngClass]="'text-gradient-' + submodule.theme">{{ submodule.title | translate }}</h3>
        <p class="module-desc">{{ submodule.description | translate }}</p>
      </div>

      <!-- Badge decorativo -->
      <div class="card-badge" [ngClass]="'badge-' + submodule.theme">
        <span class="iconify" data-icon="solar:verified-check-bold"></span>
      </div>
    </div>
    }
  </div>
</div>
